// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"249":"d4713ac1","998":"e4e65efc"}[chunkId] + ".chunk.js";
};